import BaseModel from '../base/BaseModel.model';
export default class ExperienceUser extends BaseModel {
    public userId?: number;
    public countryId?: number;
    public oorganization?:  string;
    public periodStart?: Date | any;
    public periodEnd?:  Date | any;
    public position?:  string;
    public isYourActualWork:Boolean =  false;
    public place?: string;
    public description?: string;
    public descriptionUI?: string;

    constructor(){
        super();

        this.init();
    }

    init(){ 
        this.userId = undefined;
        this.countryId = undefined;
        this.oorganization = '';
        this.place = "";
        this.position = "";   
        this.description = "";
        this.descriptionUI = "";
        this.isYourActualWork = false;

        
    }
}